<template>
    <div>
        <div class="text-center">
            <img
                v-if="enableMode"
                src="@/assets/images/auth/2-fa-verified.svg"
                alt="verified"
                class="w-128-px mb-4"
            />
            <img
                v-else
                src="@/assets/images/auth/2-fa-disabled.svg"
                alt="verified"
                class="w-128-px mb-4"
            />
            <div class="text-semi-xl text-grey font-weight-600">
                {{
                    enableMode
                        ? $t('auth.two_factor_authentication_verified')
                        : $t('auth.two_factor_authentication_disabled')
                }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TwoFANotify',
    props: {
        enableMode: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
};
</script>

<style scoped></style>
